import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    chip: {
        minWidth: 300,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        paddingTop: 25,
        paddingBottom: 25,
        margin: 5,
        border: '1px solid',
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.secondary.main
    },
    avatar: {
        backgroundColor: theme.palette.secondary.main,
        height: 30,
        width: 30
    },
    userInfo: {
        marginLeft: 15
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-evenly"
    },
    name: {
        color: theme.palette.text.primary,
        fontWeight: "bold"
    },
    email: {
        color: theme.palette.text.secondary
    },
}));

export {useStyles};
